import axios from 'axios';
import {
  FETCH_TRADE_FEES_SUCCESS,
  FETCH_TRADE_FEES_FAIL,
} from './types';

export const fetchTradeFees = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/fees';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_TRADE_FEES_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_TRADE_FEES_FAIL, errors: error });
    }

    return dispatch({ type: FETCH_TRADE_FEES_FAIL });
  }
};
